import {baseEnvironment} from './environment.base';
export const environment = {
  ...baseEnvironment,
  API_URL: '/stagEnvUrl',
  dev: true,
  baseUrl: 'https://staging.pcarelink.com/api/v1',
  encryptLocalStorage: true,
  encryptLocalStorageKey: 'f74808fb03f94ef8f64350a37918c1b0518c',
  instamed: {
    hostname: 'https://pay.instamed.com/',
    manual: false
  },
  openEdge: {
    payFieldsApiKey: '1Z86l8MtfJmz5ao7aG6mFBgn6FoKGKTy',
    environment: 'test',
    enableAutocomplete: true
  },
  host: 'https://staging.pcarelink.com',
  paymentHost: 'https://paystaging.pcarelink.com',
  inventoryURL: 'https://qa.vaxintrack.com/admin/home/inventory',
  docUrl: 'https://docs.pcarelink.com/'
};
